export default class ElementNotFoundError extends Error {}
